/**
 * Build-time stub for inactive brand Contentful APIs.
 *
 * When building for a single brand (e.g. NEXT_PUBLIC_BRAND=ug), the other
 * brands' generated `graphql/contentful-{brand}/api.ts` files may not exist.
 * next.config.ts aliases those imports to this module so the bundler resolves
 * them without error — the code paths are dead anyway.
 *
 * Turbopack validates named exports at compile time, so we must stub every
 * document node that any brand's code imports (static or destructured dynamic).
 * The values are never executed — they exist only to satisfy the module graph.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
const stub = {} as any;

// Gallet documents
export const DefaultLayoutDocument = stub;
export const HomepageDocument = stub;
export const ListingPageDocument = stub;
export const PageDocument = stub;
export const DetailPageDocument = stub;
export const PopupContentBatchDocument = stub;
export const GetAllPageSlugsDocument = stub;
export const GetAllNewsPagesDocument = stub;
export const GetAllListingPageSlugsDocument = stub;
export const SectionBackgroundDocument = stub;

// Breitling documents
export const FixedPageDocument = stub;
export const GetPlpDetailsDocument = stub;
export const ContentfulSelectorModalByMarketingPartnerDocument = stub;

// UG documents
export const LayoutDocument = stub;
